module.exports = __webpack_public_path__ + "img/logo-white.4b4e8799.png";